import React from "react";

export default function TextFieldSlug(props) {
  const { form, field } = props;
  return (
    <div>
      <label
        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
        htmlFor={field.name}
      >
        {props.label}
      </label>
      <input
        type={props.type ?? "text"}
        name={field.name}
        className={`intro-x login__input form-control ${
          form.errors[field.name] && form.touched[field.name]
            ? "border-theme-6"
            : "border-gray-300"
        } block mt-2`}
        placeholder={props.placeholder}
        style={{
          transition: "all 0.15s ease 0s",
          ...props.style,
        }}
        {...field}
        onKeyUp={(e) => {
          const value = e.target.value;
          const slug = value
            .trim()
            .replace(/[^a-zA-Z0-9\u0600-\u06FF\s]/g, "")
            .replace(/\s+/g, "-");

          form.setFieldValue(field.name, value);
          form.setFieldValue(props.slugFieldName, slug);
        }}
      />
      <div className="text-theme-6 mt-1 text-sm">
        {form.errors[field.name] &&
          form.touched[field.name] &&
          form.errors[field.name]}
      </div>
    </div>
  );
}
